import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error module not typed
import { getMessages } from 'conversations-message-history/thread-history/operators/getters';
import { WEB } from 'conversations-message-history/common-message-format/constants/clientTypes';
import { EMAIL_GENERIC_CHANNEL_ID, SMS_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { getMessageShouldIncludePreviousHistory } from 'conversations-thread-data/message-publishing/public/operators';
import { getFullName, getGates } from 'conversations-thread-data/auth/public/selectors';
import { getInboxId, getGenericChannelsUsed, getOriginalGenericChannelId, getThreadId } from 'conversations-thread-data/thread-details/public/operators';
// @ts-expect-error module not typed
import { getFocusedThreadVisitorEmailAddress } from 'conversations-thread-view/thread-details/selectors/getFocusedThreadVisitorEmailAddress';
import { getLatestMessageEditorKey } from 'conversations-thread-view/thread-histories/operators/getLatestMessageEditorKey';
import { getLastCMFGenericChannelIdFromThreadHistory } from 'conversations-thread-view/thread-histories/selectors/getLastCMFGenericChannelIdFromThreadHistory';
import { setCanShowSuspensionAlert } from 'conversations-thread-view/appeals/actions/setCanShowSuspensionAlert';
// @ts-expect-error module not typed
import { updateSeenNewFeatureShepherds } from 'conversations-thread-view/shepherds/actions/updateSeenNewFeatureShepherds';
import { ExpandableTabbedEditor, TabbedEditor } from '../../../tabbed-editor/public/components';
import { usePublishMessage } from '../hooks/usePublishMessage';
// TODO: move below to composer-data
import { useResponseStrategy } from 'conversations-thread-view/editors/hooks/useResponseStrategy';
import { FORWARD_MESSAGE } from 'conversations-thread-view/editors/constants/replyStrategies';
import { buildDisabledValidator } from '../../../disable-send/public/operators';
import { useEmptyReply } from 'conversations-thread-view/editors/hooks/useEmptyReply';
// @ts-expect-error module not typed
import { getEditorsDisabledMessage } from 'conversations-thread-view/tabbed-editors/operators/getEditorsDisabledMessage';
// @ts-expect-error module not typed
import { genericChannelIdChanged } from 'conversations-thread-view/tabbed-editors/actions/genericChannelIdChanged';
import { usePopOutEditorState } from '../../../pop-out/public/hooks';
import { useIsPopOutUngated } from '../../../pop-out/protected/hooks';
import { useCurrentEditorConfiguration } from '../hooks/useCurrentEditorConfiguration';

// @ts-expect-error module not typed

import { THREAD_COMMENT } from 'conversations-message-history/comment-message/constants/messageTypes';
import { getEditorTrackEvent } from '../../../usage-tracking/clients/usageTracker';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { useSmsCSATState } from '../hooks/useSmsCSATState';
import { jsx as _jsx } from "react/jsx-runtime";
// This wrapper is necessary to be consistent with the expandable variant
const ClassicTabbedEditor = props => /*#__PURE__*/_jsx("div", {
  className: "display-flex flex-grow-1",
  children: /*#__PURE__*/_jsx(TabbedEditor, Object.assign({}, props, {
    expandable: false
  }))
});
ClassicTabbedEditor.displayName = 'TabbedEditorWrapper';
export const BaseReplyEditor = ({
  allowFullscreen,
  associatedObjectId,
  associatedObjectTypeId,
  callingSource,
  disableCalling,
  disabled,
  disabledMessage,
  editorFragment,
  isKnownVisitor,
  onChannelChange,
  onDisabledChange,
  renderExistingFileSelect,
  replyRecommendationsEnabled,
  renderSubmitButton,
  threadDetails,
  threadHistory
}) => {
  const dispatch = useDispatch();
  const threadId = getThreadId(threadDetails);
  const gates = useSelector(getGates);
  const isUngatedForRRSettings = gates.includes('Communication:AI:ReplyRecommendationSettings');
  const latestCMFGenericChannelId = useSelector(getLastCMFGenericChannelIdFromThreadHistory);
  const originalGenericChannelId = getOriginalGenericChannelId(threadDetails);
  const threadHistoryMessages = useMemo(() => getMessages(threadHistory), [threadHistory]);
  const channelsUsed = getGenericChannelsUsed(threadDetails);
  const latestMessageEditorKey = getLatestMessageEditorKey({
    messages: threadHistoryMessages,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    channelsUsed
  });
  const defaultGenericChannelId = latestMessageEditorKey || originalGenericChannelId;
  const {
    currentConfiguration,
    currentEditorConfigKey: currentChannelId,
    isLoadingConfigurations
  } = useCurrentEditorConfiguration({
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    defaultGenericChannelId,
    editorFragment,
    onChannelChange,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    originalGenericChannelId,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    threadId
  });

  // figure out what strategy we're using to respond with and what
  // message we're replying to/forwarding, etc.
  const {
    strategy,
    messageId
  } = useResponseStrategy({
    currentChannelId,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    threadId
  });
  const userFullName = useSelector(getFullName);
  const visitorEmail = useSelector(getFocusedThreadVisitorEmailAddress);
  const {
    asyncEmptyReply
  } = useEmptyReply({
    currentChannelId,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    inboxId: getInboxId(threadDetails),
    messageId,
    strategy,
    /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    threadId,
    userFullName,
    visitorEmail,
    clientType: WEB
  });
  useEffect(() => {
    if (currentChannelId) {
      dispatch(genericChannelIdChanged({
        channelId: currentChannelId
      }));
    }
    const canShowAlert = currentChannelId === EMAIL_GENERIC_CHANNEL_ID;
    dispatch(setCanShowSuspensionAlert({
      canShowAlert
    }));
  }, [dispatch, currentChannelId]);
  disabledMessage = useMemo(() => disabledMessage || getEditorsDisabledMessage(threadDetails), [disabledMessage, threadDetails]);
  disabled = disabled || Boolean(disabledMessage);
  useEffect(() => {
    onDisabledChange({
      disabled
    });
  }, [onDisabledChange, disabled]);
  const sendDisabledValidator = useMemo(() => buildDisabledValidator({
    channelId: currentChannelId
  }), [currentChannelId]);
  const handleSelectedChange = useCallback(fragment => {
    if (editorFragment === fragment) return;
    if (fragment) onChannelChange({
      fragment
    });
  }, [editorFragment, onChannelChange]);
  const onCloseShepherd = useCallback(params => {
    const {
      allSeenShepherds
    } = params;
    dispatch(updateSeenNewFeatureShepherds({
      value: allSeenShepherds
    }));
  }, [dispatch]);
  const canReplyToSpecificMessages = currentChannelId === EMAIL_GENERIC_CHANNEL_ID;
  const includeHistory = useMemo(() => {
    return getMessageShouldIncludePreviousHistory({
      canReplyToSpecificMessages,
      isForwardingMessage: strategy === FORWARD_MESSAGE,
      latestCMFGenericChannelId,
      /*  @ts-expect-error Jun-10-2024, 18:11UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
      originalGenericChannelId
    });
  }, [canReplyToSpecificMessages, latestCMFGenericChannelId, originalGenericChannelId, strategy]);
  const {
    close: resetPopOut
  } = usePopOutEditorState('replyEditor');
  const isUngatedForPopOut = useIsPopOutUngated();
  const SelectedEditorImplementation = isUngatedForPopOut && allowFullscreen ? ExpandableTabbedEditor : ClassicTabbedEditor;
  const {
    publishMessage,
    publishComment
  } = usePublishMessage({
    asyncEmptyReply,
    capabilitiesBlob: currentConfiguration,
    threadDetails,
    includeHistory
  });
  const {
    shouldDisplaySmsCSAT,
    incrementSmsReplyCount
  } = useSmsCSATState();
  const updateHubUserAttributes = useCallback(() => {
    if (currentChannelId === SMS_GENERIC_CHANNEL_ID) {
      if (!shouldDisplaySmsCSAT) {
        incrementSmsReplyCount();
      }
    }
  }, [currentChannelId, shouldDisplaySmsCSAT, incrementSmsReplyCount]);
  const handleSubmitAndClose = useCallback((message, options) => {
    if (currentChannelId === THREAD_COMMENT) {
      publishComment(message);
    } else {
      updateHubUserAttributes();
      publishMessage(message, options);
    }
    resetPopOut();
  }, [currentChannelId, publishComment, publishMessage, resetPopOut, updateHubUserAttributes]);
  const trackEventFn = getEditorTrackEvent({
    isComposer: false,
    genericChannelId: currentChannelId
  });
  return /*#__PURE__*/_jsx(EditorTrackerContext.Provider, {
    value: {
      trackEvent: trackEventFn
    },
    children: /*#__PURE__*/_jsx(SelectedEditorImplementation, {
      asyncEmptyReply: asyncEmptyReply,
      capabilitiesBlob: currentConfiguration,
      currentChannelId: currentChannelId,
      associatedObjectId: associatedObjectId,
      associatedObjectTypeId: associatedObjectTypeId,
      callingSource: callingSource,
      disableCalling: disableCalling,
      disabled: disabled,
      disabledMessage: disabledMessage,
      expandable: isUngatedForPopOut && allowFullscreen,
      isUngatedForRRSettings: isUngatedForRRSettings,
      isKnownVisitor: isKnownVisitor,
      isLoading: isLoadingConfigurations,
      latestCMFGenericChannelId: latestCMFGenericChannelId,
      onCloseShepherd: onCloseShepherd,
      onSelectedChange: handleSelectedChange,
      originalGenericChannelId: originalGenericChannelId,
      renderExistingFileSelect: renderExistingFileSelect,
      renderSubmitButton: renderSubmitButton,
      replyRecommendationsEnabled: replyRecommendationsEnabled,
      sendDisabledValidator: sendDisabledValidator,
      submitHandler: handleSubmitAndClose,
      threadDetails: threadDetails
    })
  });
};
BaseReplyEditor.displayName = 'BaseReplyEditor';
BaseReplyEditor.propTypes = {
  allowFullscreen: PropTypes.bool,
  associatedObjectId: PropTypes.number,
  associatedObjectTypeId: PropTypes.string,
  callingSource: PropTypes.string,
  disableCalling: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  editorFragment: PropTypes.string,
  isKnownVisitor: PropTypes.bool,
  onChannelChange: PropTypes.func,
  onDisabledChange: PropTypes.func,
  renderExistingFileSelect: PropTypes.func,
  renderSubmitButton: PropTypes.func,
  replyRecommendationsEnabled: PropTypes.bool,
  threadDetails: RecordPropType('ThreadDetails').isRequired,
  threadHistory: RecordPropType('ThreadHistory').isRequired
};
BaseReplyEditor.defaultProps = {
  allowFullscreen: false,
  onChannelChange: () => {},
  onDisabledChange: () => {}
};